import { Box, Tooltip, Typography } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

export function Info({ text }: { readonly text: string }) {
  return (
    <Tooltip title={text}>
      <InfoOutlined fontSize="inherit" sx={{ ml: 0.5, cursor: "help", color: "text.secondary", verticalAlign: "middle" }}
        tabIndex={0} role="img" aria-hidden={false} aria-label={text} />
    </Tooltip>
  );
}

export function Kpi({ label, value, tip }: { readonly label: string; readonly value: string; readonly tip?: string }) {
  return (
    <Box>
      <Typography variant="overline" color="text.secondary">{label}{tip && <Info text={tip} />}</Typography>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>{value}</Typography>
    </Box>
  );
}
